import { z } from 'zod'
import { makeFieldKeys, validateWithZodSchema } from '../../core/utils/utilities.ts'

const TaskAccountsModelSchema = z
  .object({
    id: z.string(),
    task_id: z.string(),
    account_id: z.string()
  })
  .strict()

export const TaskAccountsModelFields = makeFieldKeys(TaskAccountsModelSchema)

export type TaskAccountsModel = z.infer<typeof TaskAccountsModelSchema>

function validateTaskAccountsModel(data: unknown): TaskAccountsModel {
  try {
    return validateWithZodSchema(TaskAccountsModelSchema, data, 'task accounts model')
  } catch (error) {
    throw new Error(`Task accounts model validation failed: ${error}`)
  }
}
